module.exports = __webpack_public_path__ + "static/media/calendar.68af47e4.png";